import { useEffect } from 'react';
import appConfig from '../../app-config';

const EqualWebWidget = () => {
  useEffect(()=>{
    if(!window.interdeal){
      window.interdeal = {
        sitekey: appConfig.equalWebSiteKey, 
        Position: 'Left',
        pageURL: window.location.href,
        domains: {
          js: 'https://cdn.equalweb.com/',
          acc: 'https://access.equalweb.com/',
        },
        Menulang: 'EN',
        btnStyle: {
          vPosition: ['100%', '100%'],
          scale: ['0.5', '0.5'],
          color: {
            main: '#1c4bb6',
            second: '#ffffff',
          },
          icon: {
            outline: false,
            type: 1,
            shape: 'circle',
          },
        },
      };
      
      const coreCall = document.createElement('script');
      coreCall.src = `${window.interdeal.domains.js}core/5.1.2/accessibility.js`;
      coreCall.defer = true;
      coreCall.crossOrigin = 'anonymous';
      coreCall.integrity = 'sha512-PUyQFF3HFjRiVfjOiFFu+RTc0nGmLV5FN3CVw8zWFK6pVbWPAEKy9X2bTUn10GNu1EbxN56MuWu0P8ZHC6xv3Q==';
      coreCall.setAttribute('data-cfasync', 'true');
      const target = document.body || document.head;
      target.appendChild(coreCall);
    }
  },[]);
  return null;
};

export default EqualWebWidget;
